/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CounselingDto } from '../../models/counseling-dto';

export interface CounselingControllerFindById$Params {
  id: string;
}

export function counselingControllerFindById(http: HttpClient, rootUrl: string, params: CounselingControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
  const rb = new RequestBuilder(rootUrl, counselingControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CounselingDto>;
    })
  );
}

counselingControllerFindById.PATH = '/api/counseling/{id}';
